(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name FOrderService
     *@description
     *Servicio de autores
     */

    angular
        .module('appback')
        .factory('FOrderService', FOrderService);

    FOrderService.$inject = ["$http"];

    function FOrderService($http) {

        var order = {
            Getorder: Getorder,
        };

        function Getorder(id) {
            return $http.get('/backend/fabrication_order/getorder', {
                params: {
                    id: id
                },
                headers: {}
            }).then(function (response) {
                return response.data.data;
            }, function (error) {
                return error;
            });
        }

        return order;
    }
})();

